module.exports = __webpack_public_path__ + "img/step30_a_install_tray.0bc5ccfc.png";